import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const BackArrowSvgIcon = () => {
    return (
        <SvgIcon
        sx={{
            width:'15px',
            height:'16px',
        }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 16 16"
            >
                <path
                    fill="currentColor"
                    d="M.432 7.277a1 1 0 000 1.414l6.364 6.364a1 1 0 101.414-1.414L2.553 7.984 8.21 2.328A1 1 0 006.796.913L.432 7.277zm14.707-.293h-14v2h14v-2z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default BackArrowSvgIcon;